import { useQuery } from 'react-query';
import axios, { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export interface Heartbeat {
  status: number;
  time: string;
  msg: string;
  ping: number;
}

export interface HeartbeatList {
  [monitorId: string]: Heartbeat[];
}

export interface HeartbeatResponse {
  heartbeatList: HeartbeatList;
  uptimeList: Record<string, number>;
}

export const useGetHeartbeat = (slug: string = 'scriptix') => {
  const fetchHeartbeat = async (): Promise<HeartbeatResponse> => {
    const response = await axios.get<HeartbeatResponse>(
      `https://uptime.applifyer.com/api/status-page/heartbeat/${slug}`,
      { withCredentials: false }
    );
    return response.data;
  };

  return useQuery<HeartbeatResponse, AxiosError<BaseError>>(
    ['heartbeat', slug],
    fetchHeartbeat,
    {
      enabled: !!slug,
      refetchInterval: 60_000,
      refetchOnWindowFocus: false
    }
  );
};
